import React from 'react';
import { FaPhone, FaMap, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';

function VenueInfoCard({ venueDetails, openInGoogleMaps }) {
  if (!venueDetails) return null;

  return (
    <div className="venue-info-card">
      <h2 className="venue-info-card-title">Contact & Location</h2>

      {(venueDetails.full_address || venueDetails.phone) && (
        <div className="venue-info-item">
          <div className="venue-info-icon">
            <FaMapMarkerAlt />
          </div>
          <div className="venue-info-text">
            {venueDetails.full_address && (
              <>
                <p
                  onClick={openInGoogleMaps}
                  className="venue-info-clickable venue-address venue-address-desktop"
                >
                  {venueDetails.full_address}
                </p>
                <p
                  onClick={openInGoogleMaps}
                  className="venue-info-clickable venue-address venue-address-mobile"
                >
                  {(() => {
                    const parts = venueDetails.full_address.split(',').map(p => p.trim());
                    if (parts.length >= 2) {
                      const street = parts[0];
                      const cityStateZip = parts.slice(1).join(', ');
                      return (
                        <>
                          {street}
                          <br />
                          {cityStateZip}
                        </>
                      );
                    }
                    return venueDetails.full_address;
                  })()}
                </p>
              </>
            )}
          </div>
          <div className="icon-action-group">
            <button
              className="icon-action-btn"
              onClick={openInGoogleMaps}
              aria-label="Open in maps"
            >
              <FaMap />
            </button>
            {venueDetails.phone && (
              <a
                href={`tel:${venueDetails.phone}`}
                className="icon-action-btn"
                aria-label="Call venue"
              >
                <FaPhone />
              </a>
            )}
          </div>
        </div>
      )}

      {(venueDetails.booking_url || venueDetails.services_url) && (
        <div className="venue-cta-buttons">
          {venueDetails.booking_url && (
            <a
              href={venueDetails.booking_url}
              target="_blank"
              rel="noopener noreferrer"
              className="venue-cta-btn primary"
            >
              <FaCalendarAlt /> Book Now
            </a>
          )}
          {venueDetails.services_url && (
            <a
              href={venueDetails.services_url}
              target="_blank"
              rel="noopener noreferrer"
              className="venue-cta-btn secondary"
            >
              View Services
            </a>
          )}
        </div>
      )}
    </div>
  );
}

export default VenueInfoCard;
